import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  SecurityContext,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserOperation } from 'src/app/core/enums/user-operation';
import { ShiveDialogService } from '../../../../core/services/controls/shive-dialog.service';
import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';
import { UserModel } from '../../../../core/models/user/user.model';
import { SubSink } from 'subsink';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { UsersHttpService } from '../../../../core/state/users/users-http.service';
import { UserService } from '../../../../pages/user/services/user.service';

@Component({
  selector: 'app-add-member-dialog',
  templateUrl: './add-member-dialog.component.html',
  standalone: false,
})
export class AddMemberDialogComponent implements OnInit, OnDestroy {
  @ViewChild('dialogFooter') dialogFooter: TemplateRef<unknown>;
  @Input() multiSelect = true;
  @Input() selectedUser: UserModel;
  @Input() membersInGrid: UserModel[];
  @Input() filterSelf?: null | boolean = null;
  @Input() extraFields?: TemplateRef<{ form: FormGroup }>;
  @Input() beforeSubmitted: (payload?: any) => any;

  public UserOperation = UserOperation;
  public userForm: FormGroup;
  public filteredMembers: UserModel[] = [];
  public isLoadingUsers = false;
  public readonly faCirclePlus = faCirclePlus;
  public readonly SecurityContext = SecurityContext;
  private readonly subs = new SubSink();

  constructor(
    private readonly usersHttpService: UsersHttpService,
    private readonly formBuilder: FormBuilder,
    private readonly userService: UserService,
    private readonly shiveDialogService: ShiveDialogService,
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.loadUsers();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public submit(): void {
    const selectedUser = this.userForm.get('user')!.value as UserModel;
    let result = selectedUser;
    if (this.beforeSubmitted) {
      result = this.beforeSubmitted(selectedUser) ?? selectedUser;
    }
    this.shiveDialogService.close(result);
  }

  public close(): void {
    this.shiveDialogService.close(UserOperation.Cancel);
  }

  private initForm(): void {
    this.userForm = this.formBuilder.group({
      user: [this.selectedUser, Validators.required],
    });
  }

  private loadUsers(): void {
    this.isLoadingUsers = true;
    this.subs.sink = this.usersHttpService
      .getUsers(this.filterSelf!)
      .pipe(
        switchMap((allMembers) => {
          const filteredMembers = this.userService.filterAlreadyAddedMembers(
            allMembers,
            this.membersInGrid,
          );
          return of(filteredMembers);
        }),
      )
      .subscribe((filteredMembers) => {
        this.filteredMembers = [...filteredMembers];
        this.isLoadingUsers = false;
      });
  }
}
